/**
 * Vanilla-JS countdown for [data-event-countdown]. The ISO datetime is
 * already server-rendered as the attribute value, so the date stays
 * visible/meaningful even with JS disabled — this only fills in the
 * days/hours/minutes numbers. No seconds (avoids a 1x/sec re-render),
 * and the tick is paused entirely under prefers-reduced-motion.
 */

const UPDATE_INTERVAL_MS = 30000;

export function initEventCountdown() {
  const nodes = document.querySelectorAll('[data-event-countdown]');

  if (!nodes.length) {
    return;
  }

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  nodes.forEach((node) => {
    const target = new Date(node.getAttribute('data-event-countdown')).getTime();

    if (Number.isNaN(target)) {
      return;
    }

    const dayEl = node.querySelector('[data-countdown-days]');
    const hourEl = node.querySelector('[data-countdown-hours]');
    const minuteEl = node.querySelector('[data-countdown-minutes]');

    function tick() {
      const diff = target - Date.now();

      if (diff <= 0) {
        node.setAttribute('hidden', '');
        return false;
      }

      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);

      if (dayEl) dayEl.textContent = String(days);
      if (hourEl) hourEl.textContent = String(hours);
      if (minuteEl) minuteEl.textContent = String(minutes);

      return true;
    }

    if (!tick() || reduceMotion) {
      return;
    }

    const intervalId = window.setInterval(() => {
      if (!tick()) {
        window.clearInterval(intervalId);
      }
    }, UPDATE_INTERVAL_MS);
  });
}
